export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./vegas.vue?vue&type=template&id=2fe2abd2"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/vegas.vue?vue&type=template&id=2fe2abd2
// module id = Eqx5
// module chunks = 0